// Keep in sync with the rate-base sets in BillingConstants.java.
const RATE_BASE_LABELS = {
  OCS: 'OCS Rate Card',
  cs_cs_markup: 'Use CS Rate With CS Markup',
  cs_non_cs_markup: 'Use CS Rate With Non-CS Markup',
  cs_no_markup: 'Use CS Rate With No Markup',
  cs_cs_acc_markup: 'Use CS Rate With CS Account Markup',
  cs_non_cs_acc_markup: 'Use CS Rate With Non-CS Account Markup',
  cs_cs_rate_ncs_acc_markup: 'Use CS Rate With CS Markup and Non-CS Account Markup',
  cs_ncs_rate_cs_acc_markup: 'Use CS Rate With Non-CS Markup and CS Account Markup',
  shipvia_cs_markup: 'Use Shipvia Rate With CS Markup',
  shipvia_non_cs_markup: 'Use Shipvia Rate With Non-CS Markup',
  shipvia_no_markup: 'Use Shipvia Rate With No Markup',
  shipvia_cs_acc_markup: 'Use Shipvia Rate With CS Account Markup',
  shipvia_non_cs_acc_markup: 'Use Shipvia Rate With Non-CS Account Markup',
  shipvia_cs_rate_ncs_acc_markup: 'Use Shipvia Rate With CS Markup and Non-CS Account Markup',
  shipvia_ncs_rate_cs_acc_markup: 'Use Shipvia Rate With Non-CS Markup and CS Account Markup',
  shipvia_markup_only: 'Use Shipvia Account Markup Only',
};

const RATE_BASE_OPTIONS = Object.entries(RATE_BASE_LABELS).map(([ key, value ]) => ({ key, value }));

const EXC_FR_SUFFIX = '_exc_fr';
const EXC_FR_LABEL = ', Exclude Fuel and Delivery';
const DIFF_SHIPVIA_PREFIX = 'diffshipvia::';
const DIFF_SHIPVIA_DELIMITER = '::';

// Mirrors RateBaseCodec.java: "diffshipvia::<SHIPVIA>::<core_token>" -> { shipvia, core }.
export const parseDiffShipvia = (rateBase) => {
  const raw = rateBase == null ? '' : String(rateBase);
  if (raw.startsWith(DIFF_SHIPVIA_PREFIX)) {
    const rest = raw.slice(DIFF_SHIPVIA_PREFIX.length);
    const idx = rest.indexOf(DIFF_SHIPVIA_DELIMITER);
    if (idx > 0 && idx + DIFF_SHIPVIA_DELIMITER.length < rest.length) {
      return { shipvia: rest.slice(0, idx), core: rest.slice(idx + DIFF_SHIPVIA_DELIMITER.length) };
    }
  }
  return { shipvia: null, core: raw };
};

// "[diffshipvia::<SV>::]<core>[_exc_fr]" -> { shipvia, core, excludeFuel }, core without the suffix.
export const decomposeRateBase = (rateBase) => {
  const { shipvia, core } = parseDiffShipvia(rateBase);
  const excludeFuel = core.endsWith(EXC_FR_SUFFIX);
  return {
    shipvia,
    core: excludeFuel ? core.slice(0, -EXC_FR_SUFFIX.length) : core,
    excludeFuel,
  };
};

// Inverse of decomposeRateBase; returns null when no core token is chosen.
export const composeRateBase = ({ shipvia, core, excludeFuel }) => {
  if (!core) {
    return null;
  }
  const token = excludeFuel ? `${core}${EXC_FR_SUFFIX}` : core;
  return shipvia ? `${DIFF_SHIPVIA_PREFIX}${shipvia}${DIFF_SHIPVIA_DELIMITER}${token}` : token;
};

const formatCoreRateBase = (code) => {
  const hasExcFr = code.endsWith(EXC_FR_SUFFIX);
  const baseCode = hasExcFr ? code.slice(0, -EXC_FR_SUFFIX.length) : code;
  const label = RATE_BASE_LABELS[baseCode];
  if (!label) {
    return code;
  }
  return hasExcFr ? `${label}${EXC_FR_LABEL}` : label;
};

export const formatRateBase = (code) => {
  if (code === null || code === undefined || code === '') {
    return code;
  }
  const { shipvia, core } = parseDiffShipvia(code);
  const label = formatCoreRateBase(core);
  return shipvia ? `${label} (via ${shipvia})` : label;
};

export { RATE_BASE_LABELS, RATE_BASE_OPTIONS };
